// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.T3wla{border-bottom:1px solid #0000001a;display:flex;justify-content:space-between;padding:.5rem .7rem}.T3wla .aHfUh,.T3wla .fhFQ2{align-items:center;display:flex;flex:1 0;justify-content:center}.T3wla .aHfUh .ui.action.input:not([class*="left action"]):not(.mgQPP)>input{border-bottom-right-radius:.2857rem!important;border-right-color:#22242626!important;border-top-right-radius:.2857rem!important}.T3wla .aHfUh .ui.action.input:not([class*="left action"]):not(.mgQPP)>input:focus{border-right-color:#85b7d9!important}.T3wla .lG7US{display:flex;flex:1 0;justify-content:flex-end}.T3wla div *{outline:none}.T3wla .Tyti8{display:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `T3wla`,
	"filter": `aHfUh`,
	"pageSize": `fhFQ2`,
	"noRightBorder": `mgQPP`,
	"pagination": `lG7US`,
	"hide": `Tyti8`
};
module.exports = ___CSS_LOADER_EXPORT___;
